import { Link } from 'react-router-dom'

interface EmptyOverviewCardProps {
  title: string
  description: string
  bidId: string
  linkTo?: string
}

export function EmptyOverviewCard({
  title,
  description,
  bidId,
  linkTo,
}: EmptyOverviewCardProps) {
  return (
    <section>
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-sm font-medium">{title}</h2>
        {linkTo && (
          <Link
            to={`/app/bids/${bidId}/${linkTo}`}
            className="text-xs text-[hsl(var(--link))] hover:underline"
          >
            View {title.toLowerCase()}
          </Link>
        )}
      </div>
      <div className="rounded-lg bg-muted/40 p-4">
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </section>
  )
}
